import { createAction } from '@reduxjs/toolkit';

export const clearPostCoOrder = createAction('clearPostCoOrder');
export default clearPostCoOrder;
